/** A host name or IP address for the mail server - no scheme, path, port or space. */
export const SMTP_HOST = /^(?=.{1,253}$)[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Portals PST fetches from with the office's account (ADR 0023,
 * PLAN-PORTALE.md), in the order of the plan: lowest risk of a ban first.
 */
export const PORTAL_IDS = ['ausschreiben', 'baupreislexikon', 'heinze'];
export const PORTAL_THROTTLE_DEFAULTS = {
    dailyLimit: 300, pauseMinSeconds: 15, pauseMaxSeconds: 40, burstEvery: 50, burstPauseMinutes: 10,
    downloadPauseSeconds: 60, windowStart: '01:00', windowEnd: '05:00', runMinutes: 90,
};
/**
 * What PST suggests when the night round of a portal is switched on for the
 * first time (PLAN-PORTALE.md 3.4b); saved values are never replaced without
 * a click. heinze.de gets the smallest bounds - an estimate, not tried out.
 */
export const PORTAL_THROTTLE_RECOMMENDED = {
    ausschreiben: PORTAL_THROTTLE_DEFAULTS,
    baupreislexikon: PORTAL_THROTTLE_DEFAULTS,
    heinze: {
        dailyLimit: 100, pauseMinSeconds: 30, pauseMaxSeconds: 90, burstEvery: 25, burstPauseMinutes: 15,
        downloadPauseSeconds: 120, windowStart: '01:00', windowEnd: '05:00', runMinutes: 60,
    },
};
/** The fixed bounds, enforced by the server whatever is entered. */
export const PORTAL_THROTTLE_BOUNDS = {
    dailyLimit: { min: 1, max: 2000 },
    pauseMinSeconds: { min: 5, max: 600 },
    pauseMaxSeconds: { min: 5, max: 1200 },
    burstEvery: { min: 5, max: 500 },
    burstPauseMinutes: { min: 2, max: 120 },
    downloadPauseSeconds: { min: 15, max: 1200 },
    runMinutes: { min: 5, max: 240 },
};
//# sourceMappingURL=connections.js.map